/**
 * Constants for stepper step IDs and URL paths
 */

// Special step IDs
export const INTRO_STEP_ID = 0;
export const REVIEW_STEP_ID = 999;

// URL path constants for special steps
export const REVIEW_URL_PATH = 'review';
